// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"662":"cb7b96b5","5867":"4d5acaae","8575":"b8afda5c"}[chunkId] + ".chunk.css";
};